<template>
<div>Dim table</div>
</template>
<script>
export default {
  name: 'dimension_table'
}
</script>
